import { Formatter } from '@anwb/poncho/utilities/formatters';

/**
 * Converts gender to salutation
 * @param gender 'MALE' or 'FEMALE'
 * @returns salutation
 */
export const convertGenderToSalutation: Formatter<string, string> = (gender) =>
	gender === 'FEMALE' ? 'mevrouw' : 'meneer';
